
import { BannerMenu } from "./BannerMenu";
import { connect } from "react-redux";
import { clearOnboardingData } from "../../onboarding/actions";
import { tdaClear } from "../../tda/actions";
import { logout } from "../../login/login/actions";


import { withRouter } from "react-router-dom";

const mapDispatchToProps = dispatch => {
  return {
    clearOnboardingData: () => { dispatch(clearOnboardingData()) },
    tdaClear: () => { dispatch(tdaClear()) },
    logout: () => { dispatch(logout()) }
  };
};

const mapStateToProps = state => {
  return {
    isLoggedIn: !!((state.user && state.user.token)
        || (state.user && state.user.onboarding_token)),
    client: state.client,
    app: state.app,
  }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BannerMenu));
